export default {
      id: "chevrons-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#chevrons-left",
      toString: function () {
        return this.url;
      }
    }